import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { MapPin, MessageCircle, Tag } from 'lucide-react';
import { toast } from 'sonner';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { api, fmtUSD } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { JobeurCard } from '@/components/JobeurCard';
import { SecurityBanner } from '@/components/SecurityBanner';

export default function ServiceDetailPage() {
  const { id } = useParams();
  const [s, setS] = useState(null);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => { api.get(`/services/${id}`).then((r) => setS(r.data)); }, [id]);

  const contact = async () => {
    if (!user) { toast.error('Connectez-vous pour contacter'); return nav('/login'); }
    if (user.id === s.jobeur_id) { toast.info("C'est votre propre service"); return; }
    const r = await api.post('/conversations', {
      other_user_id: s.jobeur_id,
      service_id: s.id,
      initial_message: `Bonjour, je suis intéressé(e) par votre service « ${s.title} ».`,
    });
    nav(`/messages/${r.data.conversation.id}`);
  };

  if (!s) return <div className="max-w-3xl mx-auto p-6">Chargement…</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 space-y-4" data-testid="service-detail-page">
      <Card className="p-6">
        <span className="inline-flex items-center gap-1 text-xs bg-[#EAF3FF] text-[#0E3F80] px-2 py-0.5 rounded-full border border-[#C7E2FF]">
          <Tag size={11} /> {s.category}
        </span>
        <h1 className="text-2xl md:text-3xl font-bold mt-2">{s.title}</h1>
        <p className="text-sm text-slate-600 mt-1 flex items-center gap-1"><MapPin size={14} /> {s.jobeur_commune}, {s.jobeur_city}</p>
        <p className="mt-4 text-slate-700 leading-relaxed whitespace-pre-wrap">{s.description}</p>
        <div className="mt-6 flex items-center justify-between border-t border-[#E2E8F0] pt-4">
          <div>
            <p className="text-xs text-slate-600">Tarif</p>
            <p className="text-2xl font-bold font-mono-num text-[#1677F2]">{fmtUSD(s.price_cents)} {s.price_type === 'hourly' ? '/h' : ''}</p>
          </div>
          <Button onClick={contact} className="bg-[#1677F2] hover:bg-[#0F5FCC]" data-testid="service-contact-btn">
            <MessageCircle size={16} className="mr-1" /> Contacter le jobeur
          </Button>
        </div>
      </Card>

      <SecurityBanner variant="compact" />

      <Card className="p-4">
        <Link to={`/jobeur/${s.jobeur_id}`}>
          <JobeurCard jobeur={{
            id: s.jobeur_id,
            first_name: s.jobeur_name?.split(' ')[0] || '',
            last_name: s.jobeur_name?.split(' ').slice(1).join(' ') || '',
            photo_base64: s.jobeur_photo,
            city: s.jobeur_city,
            commune: s.jobeur_commune,
            rating_avg: s.jobeur_rating_avg,
            rating_count: s.jobeur_rating_count,
            phone_verified: s.jobeur_phone_verified,
            id_verified: s.jobeur_id_verified,
          }} />
        </Link>
      </Card>
    </div>
  );
}
